module.exports = __webpack_public_path__ + "img/cfc481b.png";